import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useApi } from '@backstage/core-plugin-api';
import { analyticsApiRef } from '../api';

/**
 * Hook to automatically track page views
 * Strips query strings from the page URL before tracking
 * Excludes /analytics/* pages from tracking
 */
export const useAnalyticsTracking = () => {
  const location = useLocation();
  const analyticsApi = useApi(analyticsApiRef);
  const lastTrackedPage = useRef<string>('');

  useEffect(() => {
    // Strip query strings and hash from the path
    const page = location.pathname;

    // Don't track analytics pages themselves
    if (page.startsWith('/analytics')) {
      return;
    }

    // Only track if the page has changed (ignore query string changes)
    if (page !== lastTrackedPage.current) {
      lastTrackedPage.current = page;
      
      analyticsApi.trackPageView(page).catch(error => {
        // Silently fail to avoid disrupting user experience
        console.warn('Failed to track page view:', error);
      });
    }
  }, [location, analyticsApi]);
};
